import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit, PipeDecorator, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dettaglio-segnalazione',
  templateUrl: './dettaglio-segnalazione.component.html',
  styleUrls: ['./dettaglio-segnalazione.component.css']
})
export class DettaglioSegnalazioneComponent implements OnInit {
  idInvio: string;
  idEnte: string;
  isLoading: boolean;
  isError: boolean;
  dataToRender: ModelEventiCalamitosi.SegnalazioneDaInviareDTO;

  public readonly displayedColumns: string[] = ['codiceSegnalazione', 'tipoRichiesta', 'descrizioneSegnalazione', 'stato', 'flRettificata', 'identificativoInvio'];
  public dataSource: MatTableDataSource<ModelEventiCalamitosi.RichiestaInSegnalazioneDTO> = new MatTableDataSource<ModelEventiCalamitosi.RichiestaInSegnalazioneDTO>([]);
  private _sort: MatSort | undefined;
  @ViewChild(MatSort)
  set sort(value: MatSort) {
    this._sort = value;
    if (this._sort && this.dataSource.data.length > 0) {
      this.dataSource.sort = this._sort;
    }
  }

  constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    try {
      this.activatedRoute.params.subscribe(params => {
        this.idEnte = params['idEnte'];
        this.idInvio = params['idInvio'];
      })

      let searchParams = new HttpParams();
      searchParams = searchParams.append('idEnte', `${this.idEnte}`);
      searchParams = searchParams.append('idInvio', `${this.idInvio}`);

      this.isError = false;
      this.isLoading = true;
      this.http.get(`${environment.urls.base}/invii/list`, {
        params: searchParams
      }).subscribe((data: { content: ModelEventiCalamitosi.SegnalazioneDaInviareDTO[] }) => {
        try {
          this.dataToRender = data.content[0];

          this.parseJsonAttributes();

          this.dataSource = new MatTableDataSource(this.dataToRender?.jsonAttributi);

          this.completedLog();
        } catch (e: any) {
          this.errorLog(e);
        }
      })
    } catch (e: any) {
      this.errorLog(e);
    }
  }

  private parseJsonAttributes(): void {
    if (typeof this.dataToRender.jsonAttributi === 'string') {
      this.dataToRender.jsonAttributi = JSON.parse(this.dataToRender.jsonAttributi);
    }
  }

  private errorLog(e: any): void {
    this.isLoading = false;
    this.isError = true;
  }

  private completedLog(): void {
    this.isLoading = false;
    this.isError = false;
  }

  public isDateField(fieldName: string): boolean {
    return fieldName.toLowerCase().includes('data');
  }
}
